/*
 * Similar Products - for PDP pages
 *
 **/
require('custom/type-design-id');
require('custom/gtm-handler'); // Google Tag Manager Handler
require('custom/product-card-pillow');
import {
  EXCLUDE_FILTER,
  USER_UNAUTH_COLLAB,
  DEFAULT_ATTR_TO_RETRIEVE,
  HIDE_COLLAB,
} from '../common/constant';

custom.similarProducts = (function () {
  /**
   * Similar Products Search by Algolia
   * @params options - An options object
   * @requires options.id - Algolia Search Account ID
   * @requires options.key - Algolia Search Key
   * @requires options.searchIndex - Instant Search Index
   */
  const init = (item = {}, options = {}) => {
    // Presets
    const defaults = {
      id: algoliaShopify.config.app_id, // Account ID
      key: algoliaShopify.config.search_api_key, // Account Key
      searchIndex: window.AlgoliaIndices.products, // InstantSearch Index
      searchLimit: 4, // Hits per page
      instantSearchFilter: '', // Type to filter (ie. Rugs, Latest, etc)
      resultsWrapperClass: 'js-similar-products',
      resultsContainerID: 'similar-products-container', // Results ID
      attributesToRetrieve: null,
      cardRenderedCallback: null, // Do something with UI after rendering
      resultsLoadedCallback: null, // Do something after payload is added to DOM
    };

    // Merge args
    const opts = Object.assign({}, defaults, options);

    // Test for Algolia Account ID (required)
    try {
      if (!opts.id) {
        throw 'Please provide an Algolia Account ID (options.id)';
      }
    } catch (e) {
      console.log('error: ', e);
      return;
    }

    // Test for Algolia Account Key (required)
    try {
      if (!opts.key) {
        throw 'Please provide an Algolia Account Key (options.key)';
      }
    } catch (e) {
      console.log('error: ', e);
      return;
    }

    // Test for instantSearchIndex (required)
    try {
      if (!opts.searchIndex) {
        throw 'Please provide an Algolia Search Index (options.instantSearchIndex)';
      }
    } catch (e) {
      console.log('error: ', e);
      return;
    }

    // Attributes needed to render
    if (!opts.attributesToRetrieve)
      opts.attributesToRetrieve = DEFAULT_ATTR_TO_RETRIEVE;

    // ---------- Filter & Filter Facets Query
    let filters = `${EXCLUDE_FILTER} AND NOT handle:${item.handle} AND product_type:'${item.product_type}'`;
    if (item.collection && item.collection != '')
      filters += ` AND NOT named_tags.Collection:'${item.collection}'`;
    let facetFilters = [];
    let optionalFilters = [];
    let numericFilters = [];

    // 01. Price - Price Range
    if (item.price && item.price != '') {
      // Use Variant Universal Price (meta.loloi.price) to filter
      if (item.product_type != 'THROWS')
        numericFilters.push(
          `meta.loloi.price>=${
            custom.utils.getPriceRange(item.price).split(':')[0]
          }`,
          `meta.loloi.price<=${
            custom.utils.getPriceRange(item.price).split(':')[1]
          }`,
        );
    }
    // 02. Color
    if (item.color && item.color != '') {
      facetFilters.push(`named_tags.Color:${item.color}<score=4>`);
    }
    // 03. Style
    if (item.style && item.style != '') {
      facetFilters.push(`named_tags.Style:${item.style}<score=1>`);
    }
    // 04. Material
    if (item.material && item.material != '') {
      if (item.product_type != 'THROWS')
        facetFilters.push(`named_tags.Material:${item.material}<score=1>`);
    }
    // 05. Construction
    if (item.construction && item.construction != '') {
      if (item.product_type != 'THROWS')
        facetFilters.push(
          `named_tags.Construction:${item.construction}<score=1>`,
        );
    }
    // 06. Collaboration (include)
    if (item.collaboration && item.collaboration != '') {
      if (item.product_type != 'THROWS')
        optionalFilters.push(
          `named_tags.Collaboration:${item.collaboration}<score=1>`,
        );
    }
    // 07. Collaboration (exclude)
    if (USER_UNAUTH_COLLAB) {
      USER_UNAUTH_COLLAB.forEach(function (collaboration, index) {
        facetFilters.push(`named_tags.Collaboration:-${collaboration}`);
      });
    }

    // 07. Size (RUGS only)
    if (item.size && item.size != '') {
      const size = item.product_type != 'RUGS' ? '' : item.size;
      if (item.product_type == 'RUGS')
        facetFilters.push(`meta.loloi.variant_option:${size}`);
    }

    // Initialize search client
    if (opts.searchIndex) {
      const searchClient = algoliasearch(opts.id, opts.key);
      opts.mySearch = searchClient.initIndex(opts.searchIndex);
    }

    function renderCallback() {
      custom.typeDesignId.init();
      custom.lazyImages.init();
      custom.gtmHandler.init();
      custom.productCardPillow.init();
      custom.lazyImages.reinit();
    }

    /**
     * getSimilarProducts
     * @params options - An options object
     *
     * Call algolia search API, returns Promise object
     */
    const getSimilarProducts = (item) => {
      if (!opts.searchIndex) return;

      if (item.similar_collections.length > 0) {
        var curatedFilters = '';

        numericFilters = [];
        facetFilters = [];
        optionalFilters = [];

        item.similar_collections.forEach(function (collection, index) {
          curatedFilters +=
            index == item.similar_collections.length - 1
              ? ` named_tags.Collection:"${collection.title}"`
              : ` named_tags.Collection:"${collection.title}" OR`;
        });
        curatedFilters += ` AND NOT handle:"${item.handle}"`;
        facetFilters.push(`named_tags.Color:${item.color}<score=4>`);
      }

      return opts.mySearch.search('', {
        hitsPerPage: opts.searchLimit,
        distinct: true,
        attributesToRetrieve: opts.attributesToRetrieve,
        filters: curatedFilters ? curatedFilters : filters,
        facetFilters: facetFilters,
        numericFilters: numericFilters,
        optionalFilters: optionalFilters,
      });
    };

    /**
     * renderSimilarProducts
     * @params hits - algolia results object
     *
     * Render each result after object manipuration,
     * Hide if no result from Algolia.
     */
    const renderSimilarProducts = (hits, item_list_name, item_list_id) => {
      if (hits.length > 0) {
        // Variables
        let outputArray = [];
        let variantPricePromises = [];
        let variantsPromises = [];
        let similarSkus = [];
        var hitsLength = hits.length;
        var hideScroll = hitsLength < 3 ? true : false;
        var justifyCenter = hitsLength < 4 ? true : false;

        if (hideScroll) {
          $(`.${opts.resultsWrapperClass}`)
            .find('.fauxUi-track')
            .addClass('hidden');
          $(`.${opts.resultsWrapperClass}`)
            .find('.fauxUi-target')
            .addClass('hidden');
        }
        if (justifyCenter)
          $(`.${opts.resultsWrapperClass}`)
            .find('.scrollable-div')
            .addClass('lg-up:justify-center');

        while (hitsLength > 0) {
          outputArray.push('');
          hitsLength--;
        }

        //matches found append content to section container
        hits.forEach((hit, index) => {
          hit = custom.algoliaUtils.resultObjectReducer(hit);
          hit.index = index + 1;
          hit.item_list_name = item_list_name;
          hit.item_list_id = item_list_id;
          if (hit.named_tags && hit.named_tags.Collaboration)
            hit.hideCollaboration =
              HIDE_COLLAB.indexOf(hit.named_tags.Collaboration) >= 0;

          // fetch variants for price
          const variantFetchForPrice = custom.shopifyApi.getShopifyProductJson(
            hit.handle,
          );
          variantPricePromises.push(variantFetchForPrice);
          variantFetchForPrice.then((data) => {
            if (data) {
              // get sku of the variants to fetch prices from custom app
              data.product.variants.forEach((variant) => {
                similarSkus.push(variant.sku);
              });
            }
          });
          /**
           * NOTE: NEEDS REFACTOR HERE since similar logic is in algolia-search.js
           */
          hit['lazyload'] = true;
          if (
            hit.product_type === 'PILLOWS' ||
            hit.product_type === 'WALL ART' ||
            hit.product_type === 'POUFS'
          ) {
            const variantFetch = custom.shopifyApi.getShopifyProductJson(
              hit.handle,
            );
            variantsPromises.push(variantFetch);
            variantFetch.then((data) => {
              if (!data) {
                if (opts.passDataToTemplate) {
                  outputArray[index] += opts.passDataToTemplate(hit);
                }
              } else {
                hit['hover_img'] = '';
                if (!window.touchDevice) {
                  const hoverImg = custom.algoliaUtils.getHoverImage(data);
                  hit['hover_img'] = hoverImg ? hoverImg : '';
                }
                const sizes =
                  hit.product_type === 'PILLOWS' || hit.product_type === 'POUFS'
                    ? custom.algoliaUtils.getPillowSizeObject(data)
                    : custom.algoliaUtils.getArtSizeObject(data);
                hit = Object.assign({}, hit, { sizes: sizes });
                if (sizes) {
                  outputArray[index] += window.pillowCardTemplate.render(hit);
                } else {
                  if (opts.passDataToTemplate) {
                    outputArray[index] += opts.passDataToTemplate(hit);
                  }
                }
              }
            });
          } else {
            if (hit.product_type === 'RUGS') {
              const variantFetch = custom.shopifyApi.getShopifyProductJson(
                hit.handle,
              );
              variantsPromises.push(variantFetch);
              variantFetch.then((data) => {
                if (!data) {
                  outputArray[index] += window.productCardTemplate.render(hit);
                } else {
                  hit['hover_img'] = '';
                  if (!window.touchDevice) {
                    const hoverImg = custom.algoliaUtils.getHoverImage(data);
                    hit['hover_img'] = hoverImg ? hoverImg : '';
                  }
                  outputArray[index] += window.productCardTemplate.render(hit);
                }
              });
            } else {
              outputArray[index] += window.productCardTemplate.render(hit);
            }
          }
        });

        if (variantsPromises.length > 0) {
          Promise.all(variantsPromises).then((data) => {
            document
              .getElementById(opts.resultsContainerID)
              .insertAdjacentHTML('beforeend', outputArray.join(''));
            renderCallback();
          });
        } else {
          //throws
          document
            .getElementById(opts.resultsContainerID)
            .insertAdjacentHTML('beforeend', outputArray.join(''));
          renderCallback();
        }
      } else {
        //no matches found hide this section
        document
          .getElementsByClassName(opts.resultsWrapperClass)[0]
          .classList.add('hidden');
      }
      // if (!window.touchDevice) {
      //   custom.productCardHover.init();
      // }
      return true;
    };

    // If Color blankets or Color blocks, DO NOT show similar products
    if (
      item.product_type == 'COLOR BLOCK' ||
      item.product_type == 'COLOR BLANKET'
    ) {
      document
        .getElementsByClassName(opts.resultsWrapperClass)[0]
        .classList.add('hidden');
    } else {
      getSimilarProducts(item).then((res) => {
        renderSimilarProducts(res.hits, 'Similar Products', item.handle);
        if (res.hits && res.hits.length > 0) {
          const data = {
            ecommerce: {
              currency: 'USD',
              item_list_name: 'Similar Products',
              item_list_id: item.handle,
              items: res.hits.map((hit, index) => {
                return {
                  item_id: hit.id.toString(),
                  item_name: hit.title ? hit.title : hit.name,
                  item_brand:
                    hit.named_tags && hit.named_tags.Collection
                      ? hit.named_tags.Collection
                      : '',
                  item_collaboration:
                    hit.named_tags && hit.named_tags.Collaboration
                      ? hit.named_tags.Collaboration
                      : '',
                  item_color:
                    hit.named_tags && hit.named_tags.Color
                      ? hit.named_tags.Color.toString()
                      : '',
                  index: index + 1,
                };
              }),
            },
          };
          custom.gtmDatalayer.gtmPushNew(data, 'view_item_list');
        }
        custom.pdpCollectionCarousel.init();
      });
    }
  };

  return {
    init,
  };
})();



// WEBPACK FOOTER //
// ./src/scripts/src/custom/similar-products.js